import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  resetForm,
  getNotificationConfigById,
  getFormConfig,
  modifyCustomField, //Groups
  modifyNotificationConfig,
  addNotificationConfig,
  updateNotificationConfig,
  addCustomField,
  removeCustomField,
} from 'notifications_config/actions';
import { notifications_elementsBySections } from 'notifications_config/constants';
import { getIsLoading, getPermissionsBySection } from 'lists/selectors';

import { getEditing } from 'notifications_config/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';
import { addGrowlError, addGrowlSuccess } from 'messages/actions';

import { valueFromEvent, createRoute } from 'lib/util';
import { getCustomFieldsEmployees } from 'custom_fields_employees/actions'; //Groups
import { getGroups } from 'groups/actions'; //Groups

class NotificationsConfigFormHandlers extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };

  state = { isSubmitted: false, isValid: false, isSaving: false };

  componentWillMount = () => {
    const { aid } = this.props.match.params;
    this.props.reset();
    // this.props.getFormConfig(this.props.company.id, this.props.subcompany.id);
    aid && this.props.getById(aid, this.props.company.id, this.props.subcompany.id);
    //Groups
    // this.props.getCustomFields(this.props.company.id, this.props.subcompany.id);
    // const filters = { fulltext: "cuentas_contables", columnSearch: ["module"] }; // Filtros para traer solo los grupos de empleados
    // this.props.getGroups(this.props.company.id, this.props.subcompany.id, filters);
    //Groups
  };

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true, isValid, isSaving: true }, () => {
      if (isValid) {
        const promise = this.props.notificationConfig.id
          ? this.props.update(
              this.props.notificationConfig.id,
              this.props.company.id,
              this.props.subcompany.id,
              this.props.notificationConfig
            )
          : this.props.add(
              this.props.company.id,
              this.props.subcompany.id,
              this.props.notificationConfig
            );

        promise
          .then(({ value }) => {
            this.props.success(value.message);
            this.props.history.push(
              createRoute(this.props.company.id, this.props.subcompany.id, 'notifications_config')
            );
          })
          .catch((err) => {
            this.props.error(err.message);
            this.finishSaving();
          });
      } else {
        this.props.error('error.verify');
        this.finishSaving();
      }
    });
  };

  finishSaving = () => this.setState({ isSaving: false });

  handleValueChange = (e) => this.props.modify(valueFromEvent(e));

  //Groups
  handleGroupChange = (e) => {
    const { value } = e.target;
    let _group = [{ _id: value }];
    if (value == 'null' || value == '' || value == null || value == undefined) _group = [];
    this.props.modify({ _group });
  };

  handleCustomFieldChange = (e) => this.props.modifyCustomField(valueFromEvent(e)); // Especial para custom fields
  //Groups
  getAllSections = () => {
    let allSections = [];
    for (let section in notifications_elementsBySections) {
      if (notifications_elementsBySections.hasOwnProperty(section)) {
        allSections.push(section);
      }
    }
    return allSections;
  };

  handleCheckSection = (e) => {
    const elements = notifications_elementsBySections[e.target.value];
    console.log('%c ' + elements, 'background: #222; color: #bada55');

    if (e.target.checked) {
      this.props.modify({
        elements: [...this.props.notificationConfig.elements, ...elements],
      });
    } else {
      this.props.modify({
        elements: this.props.notificationConfig.elements.filter((p) => elements.indexOf(p) === -1),
      });
    }
  };

  handleCheckPermission = (e) => {
    if (e.target.checked) {
      this.props.modify({
        elements: [...this.props.notificationConfig.elements, e.target.value],
      });
    } else {
      this.props.modify({
        elements: this.props.notificationConfig.elements.filter((p) => p !== e.target.value),
      });
    }
  };

  handleClickPermissionRow = (e, element) => {
    if (e.target.tagName !== 'INPUT') {
      if (this.props.notificationConfig.elements.indexOf(element) > -1) {
        this.props.modify({
          elements: this.props.notificationConfig.elements.filter((p) => p !== element),
        });
      } else {
        this.props.modify({
          elements: [...this.props.notificationConfig.elements, element],
        });
      }
    }
  };

  handleValidation = (isValid) => this.setState({ isValid });

  handleAddCustomField = () => this.props.addCustomField();

  handleRemoveCustomField = (index) => this.props.removeCustomField(index);

  handleAddToNotify = (element) => {
    const elementToAdd = { id: element.id, email: element.email };
    if (
      this.props.notificationConfig._usersToNotify.filter((e) => e.id === elementToAdd.id).length <=
      0
    ) {
      this.props.modify({
        _usersToNotify: [...this.props.notificationConfig._usersToNotify, elementToAdd],
      });
    }
  };

  handleRemoveToNotify = (element) => {
    const elementToRemove = { id: element.id, email: element.email };
    this.props.modify({
      _usersToNotify: this.props.notificationConfig._usersToNotify.filter(
        (p) => p.id !== elementToRemove.id
      ),
    });
  };

  render = () =>
    this.props.render({
      isSaving: this.state.isSaving,
      isSubmitted: this.state.isSubmitted,
      notifications_elementsBySections: notifications_elementsBySections,
      allSections: this.getAllSections(),
      handleAddToNotify: this.handleAddToNotify,
      handleRemoveToNotify: this.handleRemoveToNotify,

      handleAddCustomField: this.handleAddCustomField,
      handleRemoveCustomField: this.handleRemoveCustomField,
      handleSubmit: this.handleSubmit,
      handleCustomFieldChange: this.handleCustomFieldChange, //Groups
      handleGroupChange: this.handleGroupChange, //Groups
      handleValueChange: this.handleValueChange,
      handleValidation: this.handleValidation,
      handleCheckSection: this.handleCheckSection,
      handleCheckPermission: this.handleCheckPermission,
      handleClickPermissionRow: this.handleClickPermissionRow,
    });
}

const mapStateToProps = (state) => ({
  notificationConfig: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
  permissions: getPermissionsBySection(state),
});

const mapDispatchToProps = {
  add: addNotificationConfig,
  error: addGrowlError,
  getById: getNotificationConfigById,
  getFormConfig,
  modify: modifyNotificationConfig,
  getCustomFields: getCustomFieldsEmployees, //Groups
  getGroups: getGroups, //Groups
  modifyCustomField: modifyCustomField, //Groups
  reset: resetForm,
  success: addGrowlSuccess,
  update: updateNotificationConfig,
  addCustomField,
  removeCustomField,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NotificationsConfigFormHandlers)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/containers/NotificationConfigFormHandlers.js